import { Controller } from "@hotwired/stimulus"

// Opens every <details> panel before window.print() fires, then restores
// the original open state after the print dialog closes. Used by the
// "Export as PDF" button on /dashboard so the brand expert gets a complete
// printout without manually expanding every accordion first.
export default class extends Controller {
  print() {
    const panels = Array.from(document.querySelectorAll("details"))
    const wasOpen = panels.map(p => p.open)
    panels.forEach(p => { p.open = true })

    const restore = () => {
      panels.forEach((p, i) => { p.open = wasOpen[i] })
      window.removeEventListener("afterprint", restore)
    }
    window.addEventListener("afterprint", restore)

    // Give the browser a tick to lay out the now-expanded panels before
    // it captures the print preview.
    setTimeout(() => window.print(), 50)
  }
}
